const Languages = {
  en_US: 'en_US',
  pl_PL: 'pl_PL',
  default: 'pl_PL'
}

export default Languages
